import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { REWARD_CENTER_ONBOARDING_STEPS } from '../../../components/OnboardingLayer/onboardingSteps';
import QueryParamsProxy from '../../../utils/queryParamProxy';
import screens from '../../index';
import { ONBOARDING_FLOWS } from '../../../utils/onboarding';
import ENVIRONMENT_VARIABLES from '../../../utils/environmentVariables';
import routeParamConstants from '../../../utils/routeParamConstants';
import { postRewardCenter } from '../../../state/query/rewardCenter';
import store from '../../../state/store';
import { setLoadingLayer } from '../../../state/slices/layout/layout';
import Logger from '../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import ERROR_CODE from '../../../utils/errorCodes';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { REWARD_CENTER_TABS } from '../constants';

var middleware = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var navigation, notificationContext, _ref$openProfile, openProfile, rewardCenterResponse, _store$getState, _store$getState$playe, playerId, isAccountLinked, onboardingsSeen, currentStep, onboardingsSeenByPlayer, hasSeenOnboarding, modalScreen;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            navigation = _ref.navigation, notificationContext = _ref.notificationContext, _ref$openProfile = _ref.openProfile, openProfile = _ref$openProfile === void 0 ? false : _ref$openProfile;
            _context.prev = 1;
            store.dispatch(setLoadingLayer(true));
            _context.next = 5;
            return store.dispatch(postRewardCenter.initiate({
              requestAssetsData: true
            }, {
              forceRefetch: true
            })).unwrap();

          case 5:
            rewardCenterResponse = _context.sent;

            if (rewardCenterResponse) {
              _store$getState = store.getState(), _store$getState$playe = _store$getState.playerInfo, playerId = _store$getState$playe.playerId, isAccountLinked = _store$getState$playe.isAccountLinked, onboardingsSeen = _store$getState.ftue.onboardingsSeen, currentStep = _store$getState.currentOnboarding.currentStep;
              onboardingsSeenByPlayer = onboardingsSeen[playerId] || [];
              hasSeenOnboarding = onboardingsSeenByPlayer.includes(ONBOARDING_FLOWS.REWARD_CENTER) && currentStep === REWARD_CENTER_ONBOARDING_STEPS.SECOND_VISIT && isAccountLinked === 'no';
              if (hasSeenOnboarding && ENVIRONMENT_VARIABLES.LINKING_CARD_POPUP_ON_HIT_REWARD_CENTER !== 'false') modalScreen = screens.LinkCardOnboarding;else if (!onboardingsSeenByPlayer.includes(ONBOARDING_FLOWS.REWARD_CENTER)) modalScreen = screens.RewardCenterOnboarding;
              if (modalScreen) QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, modalScreen));else if (openProfile) {
                QueryParamsProxy.navigate(navigation, screens.RewardCenter, _defineProperty({}, routeParamConstants.PARAM_RC_TAB, REWARD_CENTER_TABS.PROFILE));
              } else {
                QueryParamsProxy.navigate(navigation, screens.RewardCenter);
              }
            }

            _context.next = 14;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            notificationContext.addNotification({
              title: getText(TEXT_KEY.OOPS),
              message: getText(TEXT_KEY.REWARD_CENTER_INITREWARDS_FAILED_MESSAGE)
            });
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: _context.t0.message,
              code: ERROR_CODE.INIT_REWARD_CENTER_REQUEST_ERROR
            });
            return _context.abrupt("return");

          case 14:
            _context.prev = 14;
            store.dispatch(setLoadingLayer(false));
            return _context.finish(14);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9, 14, 17]]);
  }));

  return function middleware(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default middleware;